module.exports = __webpack_public_path__ + "static/media/Stress-Black.61767ffd.png";